import { render } from "./StudentGSN.vue?vue&type=template&id=7bb61f65"
import script from "./StudentGSN.vue?vue&type=script&lang=js"
export * from "./StudentGSN.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__